module.exports = __webpack_public_path__ + "assets/img/ecg-detail-back-2.ae1e3ba4.png";